<template>
    <rkm-layout-body title="Lista de medicamento">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-medicamento-create' })"
                color="primary"
                authorize="store-cadastro-medicamento"
            >
                Cadastrar medicamento
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/medicamento/List'

export default {
    components: { List },
}
</script>